<template>
    <main>
        <div class="main__column main__column--wide shiftUp">
            <FileUpload v-if="form === 'upload'" @toggleForm="toggleForm" />
            <FilePaste v-if="form === 'paste'" @toggleForm="toggleForm" />
        </div>
    </main>
</template>

<script>
import FileUpload from './FileUpload'
import FilePaste from './FilePaste'
export default {
    name: 'Index',
    data() {
        return {
            form: 'upload', // or 'paste'
        }
    },
    components: {
        FileUpload,
        FilePaste,
    },
    methods: {
        toggleForm() {
            this.form = this.form === 'upload' ? 'paste' : 'upload'
        },
    },
}
</script>

<style lang="less">
#login_navbar {
    padding: 15px;
    display: flex;
    justify-content: flex-end;
    #login-button {
        margin-right: 10px;
    }
}
</style>

<style lang="less" scoped>
a {
    color: #2aacea;
}
#login_navbar {
    padding: 15px;
    display: flex;
    justify-content: flex-end;
    #login-button {
        margin-right: 10px;
    }
}
</style>
